var _rect, _g, _rect2, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 130,
    viewBox: "0 0 324 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10471_9796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 5,
    width: 279,
    height: 134
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.8105,
    y: 5.86987,
    width: 277.379,
    height: 132.969,
    rx: 23.6449,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10471_9796)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.302,
    cy: 120.151,
    rx: 83.0568,
    ry: 76.1876,
    fill: "#44FFDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.4021,
    cy: 106.136,
    rx: 98.3362,
    ry: 90.2032,
    fill: "#335ECC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.26,
    cy: -15.3334,
    rx: 132.029,
    ry: 121.109,
    fill: "#0DDD91"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: -16,
    width: 323,
    height: 154.839,
    rx: 23.6449,
    fill: "#F7F9FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.558,
    cy: -15.5815,
    rx: 114.51,
    ry: 105.039,
    fill: "#007B6C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.153,
    cy: 139.326,
    rx: 96.7175,
    ry: 88.7184,
    fill: "#FFD6D6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10471_9796)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: -67,
    r: 103,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: -26,
    r: 103,
    fill: "#D2F8C0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.0636,
    cy: 100.757,
    rx: 114.51,
    ry: 105.039,
    fill: "#5783F1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_10471_9796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.1736,
    cy: -40.6905,
    rx: 153.744,
    ry: 141.029,
    fill: "#0DDD91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10471_9796",
    x: -49.6708,
    y: -68.6115,
    width: 426.341,
    height: 281.932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.2407,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_10471_9796",
    x: 3.26375,
    y: -157.018,
    width: 568.077,
    height: 554.338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100.491,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_10471_9796",
    x: -216.915,
    y: -185.049,
    width: 598.635,
    height: 582.369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100.491,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_10471_9796",
    x: -224.751,
    y: -337.424,
    width: 666.021,
    height: 644.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100.491,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_10471_9796",
    x: 67.2768,
    y: -242.392,
    width: 472.562,
    height: 453.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_10471_9796",
    x: 73.664,
    y: -71.1637,
    width: 436.977,
    height: 420.979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_10471_9796",
    x: -167.217,
    y: -126.054,
    width: 472.562,
    height: 453.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_10471_9796",
    x: -176.342,
    y: -303.49,
    width: 551.031,
    height: 525.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_10471_9796"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10471_9796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 77,
    fill: "white",
    transform: "translate(144)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBg);
export default __webpack_public_path__ + "static/media/green_bg.6980a6df0af7ef73c55010f483e3427d.svg";
export { ForwardRef as ReactComponent };